/* SubColumnFormatter.js */

"use strict";

const _ = require("lodash");

let subColumnFormatter = function (row, cell, value, column, rowData) {
    let field = column.field.split(":")[1];
    let objectData = _.get(rowData, field);
    let cellValue = _.get(objectData, column.valuePath, "");
    return "<div>" + cellValue + "</div>";
};

module.exports = subColumnFormatter;
